import { ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material';
import type { FC } from 'react';
import type { Member } from '../../models/member';
import { ConversationMemberAvatar } from './conversation-member-avatar';

interface ConversationMemberItemProps {
  member: Member;
  secondaryAction?: React.ReactNode;
  onRightClick?: (event: React.MouseEvent<HTMLElement>, member: Member) => void;
}

export const ConversationMemberItem: FC<ConversationMemberItemProps> = ({ member, secondaryAction, onRightClick }) => (
  <ListItem key={member.userId} disablePadding secondaryAction={secondaryAction}>
    <ListItemButton
      disableRipple
      onContextMenu={(event) => onRightClick?.(event, member)}
      className='mex:!rounded-sm'
      sx={{ cursor: 'context-menu' }}
    >
      <ListItemAvatar className='mex:!size-8'>
        <ConversationMemberAvatar member={member} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography variant='body2' sx={{ fontWeight: 500, color: 'text.primary' }}>
            {member.user?.fullName}
          </Typography>
        }
        secondary={
          <Typography variant='caption' sx={{ color: 'text.secondary' }}>
            {member.displayRole || 'Không xác định'}
          </Typography>
        }
      />
    </ListItemButton>
  </ListItem>
);
